/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiAdminSystemSpecialityGroupsIdMappingsPost$Params {
  id: string;
      body?: Array<string>
}

export function apiAdminSystemSpecialityGroupsIdMappingsPost(http: HttpClient, rootUrl: string, params: ApiAdminSystemSpecialityGroupsIdMappingsPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAdminSystemSpecialityGroupsIdMappingsPost.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as HealthFindrStrictHttpResponse<void>;
    })
  );
}

apiAdminSystemSpecialityGroupsIdMappingsPost.PATH = '/api/Admin/system-speciality-groups/{id}/mappings';
